export const PricingTierValues = [
  'Essential',
  'Standard',
  'Premium',
  'Enterprise',
];
export type PricingTier = string;
